import { StaffProfile } from '../models/staffProfile';

const STAFF_COLOUR_PALETTE = [
  '#e74c3c', '#3498db', '#2ecc71', '#f39c12', '#9b59b6',
  '#1abc9c', '#e67e22', '#e91e63', '#00bcd4', '#8bc34a',
  '#ff5722', '#673ab7', '#009688', '#ffc107', '#607d8b',
  '#c0392b', '#2980b9', '#27ae60', '#d35400', '#7d3c98',
];

export function staffColour(id: number): string {
  return STAFF_COLOUR_PALETTE[id % STAFF_COLOUR_PALETTE.length];
}

export function nameToInitials(name: string): string {
  const parts = (name || '').trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return (parts[0]?.[0] ?? '?').toUpperCase();
}

/**
 * Decodes an active-user JWT (without signature verification — trust is handled server-side)
 * and returns a StaffProfile, or null if the token is absent/malformed/expired.
 */
export function decodeActiveUserToken(token: string | null): StaffProfile | null {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    // Reject expired tokens
    if (payload.exp && payload.exp * 1000 < Date.now()) return null;
    return {
      id:         payload.userId,
      name:       payload.name,
      email:      payload.email,
      initials:   nameToInitials(payload.name),
      // Prefer the admin-set colour carried in the token; fall back to the
      // id-indexed default for tokens issued before the colour was stored.
      colourCode: payload.colourCode ?? staffColour(payload.userId),
      hasPin:     true,
      roleIds:    payload.roleIds ?? [],
      isExternal: payload.isExternal === true,
      isSupport:  payload.isSupport === true,
    };
  } catch {
    return null;
  }
}
